// extracted by mini-css-extract-plugin
export default {"content":"Metrics_content__k3TOz","col":"Metrics_col__t9P8x"};